import React from 'react';
import _ from 'lodash';
import { BrokerApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';
import { BfiDataGrid, Column } from '../../common/SharedComponents';
import { GridSettingType } from '@apply/constants';

const BrokerClientsTable = ({ brokerId }) => {
    const brokerApi = new BrokerApi.BrokerApi(applicationInsights);

    const _loadBClients = async () => {
        const response = await brokerApi.getBrokerBClients(brokerId);

        if (response.statusCode !== 200) return;

        set_rows(
            response.result.map((s) => ({
                ...s,
            }))
        );
    };

    const [rows, set_rows] = React.useState([]);
    const [sort] = React.useState({
        column: 'calculatedStatus',
        direction: 'asc',
    });

    const sortedRows = _.chain(rows).orderBy(sort.column, sort.direction).value();

    React.useEffect(() => {
        _loadBClients();
    }, []);

    return (
        <BfiDataGrid
            dataSource={sortedRows}
            keyExpr='id'
            showBorders={true}
            showRowLines={false}
            rowAlternationEnabled={true}
            remoteOperations={false}
            allowColumnReordering={true}
            allowColumnResizing={true}
            noDataText='No B-Client records available'
            defaultPageSize={12}
            allowedPageSizes={[12]}
            applicationInsights={applicationInsights}
            gridType={GridSettingType.BrokerClientsTable}
        >
            <Column
                dataField='personName'
                caption='Person'
                width={200}
                alignment={'left'}
            />
            <Column
                dataField='clientName'
                caption='Business'
                alignment={'left'}
            />
            <Column
                dataField='status'
                caption='Status'
                width={300}
                alignment={'left'}
            />
        </BfiDataGrid>
    );
};

export default BrokerClientsTable;
